import { defineMessages } from 'react-intl';

export default defineMessages({
  deliveryAmount: {
    id: 'app.modules.shopDetails.DeliveryInfo.deliveryAmount',
    defaultMessage: 'Mínimo {minDeliveryAmount}',
  },
  deliveryAmountNoMin: {
    id: 'app.modules.shopDetails.DeliveryInfo.deliveryAmountNoMin',
    defaultMessage: 'Sin mínimo',
  },
  deliveryTime: {
    id: 'app.modules.shopDetails.DeliveryInfo.deliveryTime',
    defaultMessage: '{minMinutes} - {maxMinutes} min',
  },
  shippingAmountFree: {
    id: 'app.modules.shopDetails.DeliveryInfo.shippingAmountFree',
    defaultMessage: 'Envío gratis',
  },
  shippingAmount: {
    id: 'app.modules.shopDetails.DeliveryInfo.shippingAmount',
    defaultMessage: '{shippingAmount} envío',
  },
  finalPricePlusDesktop: {
    id: 'app.modules.shopDetails.DeliveryInfo.finalPricePlusDesktop',
    defaultMessage: 'Envío {finalPricePlus}',
  },
  finalPricePlusMobile: {
    id: 'app.modules.shopDetails.DeliveryInfo.finalPricePlusMobile',
    defaultMessage: '{finalPricePlus}',
  },
  originalPricePlus: {
    id: 'app.modules.shopDetails.DeliveryInfo.originalPricePlus',
    defaultMessage: '{originalPricePlus}',
  },
});
